import { GUID, Param } from "app/brightserve/brightserve.module";

export class Coordinate {
    Id: GUID;
    X: number;
    Y: number;
    Z: number;
    Datum: Param;

    constructor(init?: Partial<Coordinate>) {
        Object.assign(this, init);

        if (init && init.Datum) {
            this.Datum = new Param(init.Datum);
        } else {
            this.Datum = null;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/coordinate.ts